import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { bemCssModules, getTestId } from '@utils';
import { useNavigate } from '@utils/hooks';

import { FiatCurrencyEnum } from '@modules/global/types';

import style from './Accounts.scss';

const cn = bemCssModules(style, 'Accounts');
const ti = getTestId('Accounts');

export type TAccounts = {
  balance: string;
  accountNumber: string;
  isAccountCreated: boolean;
};

const Accounts: CustomFC<TAccounts> = ({ balance, accountNumber, isAccountCreated, className }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleClick = () => navigate(CONST.nav.accounts);

  const label = isAccountCreated
    ? `${FiatCurrencyEnum.EUR} · ${accountNumber.slice(-4)}`
    : FiatCurrencyEnum.EUR;

  return (
    <button type="button" onClick={handleClick} className={cn([className])} data-testid={ti()}>
      <span>{label}</span>
      <div className={cn('right')}>
        {isAccountCreated ? (
          <span>{`${balance} ${FiatCurrencyEnum.EUR}`}</span>
        ) : (
          <Link className={cn('topup')} to={CONST.nav.accounts} onClick={e => e.stopPropagation()}>
            {t('wallets.accounts.open')}
          </Link>
        )}
      </div>
    </button>
  );
};

export default Accounts;
